import { useEffect, useRef } from "react";
import { useStore } from "react-redux";


/**
 * 
 * @template T
 * @param {*} selector 
 * @returns
 */
export function hookReduxCreator(selector) {

  /**
   * @param {(data: T) => void} observer
   * @param {Array<number | string} ids
   */
  return function (observer, ids) {
    const store = useStore();
    const forwardTo = useRef(({ids, observer}));
    forwardTo.current = {
      ids,
      observer
    };
    useEffect(() => {
      const isNew = (() => {
        let oldData = {};
        return function (id, data) {
          if(oldData[id] === data) {
            return false;
          } else {
            oldData[id] = data;
            return true;
          }
        }
      })();
      return store.subscribe(function() {
        const state = selector(store.getState());
        if(!isNew('state.selector', state)) return;
        forwardTo.current.ids.forEach(id => {
          const data = state[id];
          if(!data) return;
          if(isNew(id, data)) {
            forwardTo.current.observer(data);
          }
        })
      })
    }, [store]);
  };
}